import { render, staticRenderFns } from "./twitter.vue?vue&type=template&id=55f7cfcc&"
import script from "./twitter.vue?vue&type=script&lang=ts&"
export * from "./twitter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports